import { createSearchParams } from 'react-router-dom';
import { withDashboardBreadcrumbOrigin } from './breadcrumbNavigation';

const POLICY_DASHBOARD_FILTER_TO_QUERY = {
  expiring_lt_30: { expiringRange: 'lt_30' },
  expiring_31_60: { expiringRange: '31_60' },
  expiring_61_90: { expiringRange: '61_90' },
  expiring_91_120: { expiringRange: '91_120' },
  policy_issued_past: { leaseBucket: 'past' },
  policy_issued_current: { leaseBucket: 'current' },
  policy_issued_future: { leaseBucket: 'future' },
  coverage_rent_guaranty: { appType: 'Rent Guaranty' },
  coverage_ldr: { appType: 'LDR' },
  coverage_total: {},
};

/** Policies route with query params for dashboard / report chart drill-down keys. */
export function getPoliciesPathForDashboardFilter(dashboardFilter) {
  const params = POLICY_DASHBOARD_FILTER_TO_QUERY[dashboardFilter] || {};
  const search = createSearchParams(params).toString();
  return search ? `/property/policies?${search}` : '/property/policies';
}

/** Navigate to policies list from dashboard drill-down with breadcrumb origin preserved. */
export function navigatePoliciesFromDashboardFilter(navigate, dashboardFilter) {
  navigate(getPoliciesPathForDashboardFilter(dashboardFilter), {
    state: withDashboardBreadcrumbOrigin({ dashboardFilter }),
  });
}
